import axios from 'axios';

/**
 * Confirm a lineup position for a player
 */
export async function confirmLineupPosition(
  matchId: number,
  lineupId: number,
  playerId: number
): Promise<{ message: string; confirmation: any }> {
  try {
    const response = await axios.post(
      `/lineups/matches/${matchId}/lineup/${lineupId}/confirm/${playerId}`
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      const errorMessage = error.response.data?.detail || error.response.data?.message || 'Failed to confirm lineup position';
      throw new Error(errorMessage);
    } else if (error.request) {
      throw new Error('Network error: Could not reach server');
    } else {
      throw new Error(error.message || 'Failed to confirm lineup position');
    }
  }
}

/**
 * Unconfirm a lineup position for a player
 */
export async function unconfirmLineupPosition(
  matchId: number,
  lineupId: number,
  playerId: number
): Promise<{ message: string }> {
  try {
    const response = await axios.delete(
      `/lineups/matches/${matchId}/lineup/${lineupId}/confirm/${playerId}`
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      const errorMessage = error.response.data?.detail || error.response.data?.message || 'Failed to unconfirm lineup position';
      throw new Error(errorMessage);
    } else if (error.request) {
      throw new Error('Network error: Could not reach server');
    } else {
      throw new Error(error.message || 'Failed to unconfirm lineup position');
    }
  }
}

/**
 * Confirm lineup by token (from email link)
 */
export async function confirmLineupByToken(token: string): Promise<void> {
  try {
    // This will redirect, so we just need to navigate to it
    window.location.href = `/api/lineups/lineup/confirm/${token}`;
  } catch (error: any) {
    throw new Error(error.message || 'Failed to confirm lineup');
  }
}

